import { useState, useEffect } from "react";
import { Spin } from "antd";
import service from "../../services/Service";
import { withLocale } from "../../l10n";
import { formatDate } from '../../utils/dates';

/**
 * Datos del router kiconex asociado a un dispositivo, en solo lectura.
 */
function RouterInfo({ lang, uuid, order_id }) {

  const [router, setRouter] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!uuid) {
      setRouter(null);
      return;
    }

    let cancelled = false;

    const fetchRouter = async () => {
      setLoading(true);
      try {
        const res = await service.get("routers/" + uuid);
        if (cancelled) return;
        setRouter(!res || res.data.ok === false ? null : res.data.data);
      } catch (err) {
        console.error("Error devuelto: " + err);
        if (!cancelled) setRouter(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchRouter();

    // Si cambia el router elegido antes de que responda, la respuesta vieja se tira
    return () => { cancelled = true; };
  }, [uuid]);

  if (!uuid) {
    return (
      <p className="p-3">
        {lang.handle('Este dispositivo no tiene ningún router kiconex asignado')}
      </p>
    );
  }

  if (loading) {
    return <div className="p-3"><Spin /></div>;
  }

  if (!router) {
    return (
      <p className="p-3">
        {lang.handle('No se ha podido cargar la información del router')}
      </p>
    );
  }

  const rows = [
    { label: lang.handle('Pedido'), value: order_id ?? router.order_id },
    { label: 'IMEI', value: router.modem_imei },
    { label: lang.handle('Tipo Teltonika'), value: router.modem_type_code },
    { label: lang.handle('Modelo'), value: router.model_name },
    { label: lang.handle('Versión'), value: router.version_name },
    { label: lang.handle('Número de serie'), value: router.modem_serial_number },
    { label: lang.handle('Estado'), value: router.state },
    { label: lang.handle('Fecha fabricación'), value: formatDate(router.date) },
  ];

  return (
    <div>
      {rows.map(row => (
        <div className="form-group row" key={row.label}>
          <label className="col-sm-2 col-form-label newCard-form-text"> {row.label} </label>
          <div className="col-sm-10">
            <input type="text" className="form-control" value={row.value ?? ''} disabled />
          </div>
        </div>
      ))}
    </div>
  );
}

export default withLocale(RouterInfo);
